package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet

import androidx.compose.animation.AnimatedContent
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.material3.windowsizeclass.WindowWidthSizeClass
import androidx.compose.material3.windowsizeclass.calculateWindowSizeClass
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.delay
import tta.destinigo.talktoastro.shared.local.ConfigProvider
import tta.destinigo.talktoastro.shared.persentation.CommonLoadingButton
import tta.destinigo.talktoastro.shared.persentation.expert_widget.ExpertProfileIcon
import tta.destinigo.talktoastro.shared.persentation.snackbar.ErrorBanner
import tta.destinigo.talktoastro.shared.remote.Resources
import tta.destinigo.talktoastro.shared.theme.Scale

@OptIn(ExperimentalMaterial3Api::class, ExperimentalMaterial3WindowSizeClassApi::class)
@Composable
fun QueueStatusBottomsheet(
    component: QueueStatusComponent,
) {

    val windowSizeClass = calculateWindowSizeClass().widthSizeClass
    val state = component.statusState.collectAsState()
    val queueUser = component.users.collectAsState()
    val errorMsg = component.errorMsgStat.collectAsState()

    LaunchedEffect(state.value) {
        if (state.value is Resources.Success<*>) {
            ConfigProvider.setQueueStatus(false)
            delay(1000)
            component.onDismiss.invoke(true)
        }
    }


    val content: @Composable () -> Unit = {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {

            component.errorQueueMsg?.let {

                Spacer(modifier = Modifier.height(8.dp))
            }

            ErrorBanner(
                text = errorMsg.value,
                modifier = Modifier.fillMaxWidth()
            )


            // 1. Header Section (User Avatar + Name)
            Row(
                verticalAlignment = Alignment.CenterVertically
            ) {

                ExpertProfileIcon(
                    profileImageUrl = component.expertInfo.expertProfileImageUrl,
                    modifier = Modifier.size(42.dp)
                )

                Spacer(modifier = Modifier.width(12.dp))

                Column {
                    Text(
                        text = component.expertInfo.expertName,
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold)
                    )
                    Text(
                        text = component.expertInfo.expertSkills.toString(),
                        style = MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.SemiBold)
                    )
                }
            }

           AnimatedContent(queueUser.value){ queueData ->
               when (queueData) {
                   is Resources.Error<*> -> component.setErrorMst(queueData.msg)
                   is Resources.Success<*> -> {
                       if (component.errorQueueMsg == null ) component.setErrorMst(queueData.msg)
                       onSuccess(
                           queueUser = queueData.data?.user ?:  emptyList(),
                           inactiveUserText = queueData.data?.inactiveUserText.toString()
                       )
                   }

                   else -> Box(
                       modifier = Modifier.fillMaxWidth().height(100.dp),
                       contentAlignment = Alignment.Center
                   ) {
                       CircularProgressIndicator(
                           modifier = Modifier.size(40.dp),
                           color = Color.Blue
                       )
                   }
               }
           }

            // 5. Bottom Buttons
            Spacer(modifier = Modifier.height(12.dp))

            CommonLoadingButton(
                modifier = Modifier.fillMaxWidth(),
                text = if (state.value is Resources.Success<*>) "Success! Removed from Queue" else "Exit Queue",
                isLoading = state.value is Resources.Loading<*>,
                onClick = {
                    component.removeQueue()
                }
            )
        }
    }

    if (windowSizeClass == WindowWidthSizeClass.Compact) {
        // Use BottomSheet for Compact screens
        ModalBottomSheet(
            containerColor = Color.White,
            onDismissRequest = { component.onDismiss.invoke(false) }
        ) {
            Box(
                modifier = Modifier.padding(16.dp)
            ) {
                content()
            }
        }
    } else {
        AlertDialog(
            containerColor = Color.White,
            onDismissRequest = {
                component.onDismiss.invoke(false)
            },
            text = content,
            shape = RoundedCornerShape(Scale.CORNER_SMALL),
            confirmButton = {},
            dismissButton = {}
        )
    }
}

@Composable
fun onSuccess(
    queueUser: List<QueueUser>,
    inactiveUserText:String
){
    // 3. List of Users
    Spacer(modifier = Modifier.height(12.dp))
    LazyColumn(
        verticalArrangement = Arrangement.spacedBy(4.dp),
        modifier = Modifier.fillMaxWidth().wrapContentHeight()
    ) {

        item {
            Text(
                text = "Check your spot in the queue",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }

        items(items = queueUser) { user ->
            QueueUserItem(
                user = user,
                modifier = Modifier.fillMaxWidth().animateItem()
            )
        }

        item {
            // 4. Inactive users text
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                text = inactiveUserText,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.7f)
            )
        }
    }

}
